export default "__VITE_ASSET__DNRGQCiN__"